import { render, staticRenderFns } from "./AppSkeleton.vue?vue&type=template&id=8a85a0ac"
import script from "./AppSkeleton.vue?vue&type=script&lang=js"
export * from "./AppSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AppSkeleton.vue?vue&type=style&index=0&id=8a85a0ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports